import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["date"];
  static classes = ["hidden"];
  static values = {
    selectedValue: String,
  };

  declare dateTarget: HTMLElement;
  declare hiddenClass: string;
  declare selectedValue: string;

  connect(): void {
    const selected = this.element.querySelector<HTMLInputElement>(
      "input[type='radio']:checked"
    );
    this.apply(selected?.value === this.selectedValue);
  }

  toggle(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.apply(input.checked && input.value === this.selectedValue);
  }

  apply(showDate: boolean): void {
    this.dateTarget.classList.toggle(this.hiddenClass, !showDate);
  }
}
